<div
	*ngIf="setting.getBoolean('App.ChangeLogs.SeeChangeLogs')"
	id="pt_quick_sidebar_toggle"
	class="topbar-item"
	style="height: 100%"
>
	<button [class]="customStyle" (click)="showChangelogModal()">
		<div>
			<i class="material-icons">history</i>
		</div>
	</button>
</div>
